import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { forwardRef } from 'react';
import useAppContext from 'flow/hooks/useAppContext';
import EmbeddedType from 'flow/types/embedded-type';
import BaseInput from './BaseInput';
import { jsx as _jsx } from "react/jsx-runtime";
var TimeInput = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _ref$label = _ref.label,
    label = _ref$label === void 0 ? null : _ref$label,
    defaultValue = _ref.defaultValue,
    onChange = _ref.onChange,
    ariaLabel = _ref.ariaLabel;
  var _useAppContext = useAppContext(),
    embedded = _useAppContext.embedded;
  return /*#__PURE__*/_jsx(BaseInput, _objectSpread(_objectSpread({
    label: label,
    type: "time",
    defaultValue: defaultValue,
    ref: ref,
    onChange: onChange
  }, embedded === EmbeddedType.IOS && {
    role: 'textbox'
  }), ariaLabel && {
    'aria-label': ariaLabel
  }));
});
export default TimeInput;